import React from "react";
import PropTypes from "prop-types";

const DateTimePicker = ({
  mode, // "auto" | "manual"
  date,
  onDateChange,
  half,
  onToggle,
  onTimeChange,
}) => {

  const todayStr = new Date().toISOString().split("T")[0];

  const isToday = (date) => date === todayStr;

  const getMinTime = () => {
    if (isToday(date)) {
      const now = new Date();
      return now.toTimeString().slice(0, 5);
    }
    return "00:00";
  };

  const today = isToday(date);

  return (
    <div
      className={`border p-3 rounded mb-3 transition ${
        today ? "border-blue-500 bg-blue-50 shadow-md" : "bg-white"
      }`}
    >
      {/* HEADER */}
      <div className="flex justify-between items-center mb-2">
        <label className="text-sm font-medium text-gray-600">
          {mode === "auto" ? "Date (Auto)" : "Select Date"}
        </label>

        {today && (
          <span className="text-xs bg-blue-500 text-white px-2 py-1 rounded">
            Today
          </span>
        )}
      </div>

      {/* DATE FIELD */}
      {mode === "manual" ? (
        <input
          type="date"
          className={`border p-2 rounded mb-3 w-full ${
            today ? "border-blue-500" : ""
          }`}
          value={date}
          min={todayStr}
          onChange={(e) => onDateChange(e.target.value)}
        />
      ) : (
        <div
          className={`mb-3 p-2 rounded text-sm font-medium ${
            today ? "bg-blue-100 text-blue-700" : "bg-gray-100"
          }`}
        >
          {date}
        </div>
      )}

      {/* HALF */}
      <div className="flex gap-4 items-center">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={half.isOpen}
            onChange={onToggle}
          />
          <span className="font-medium">{half.name}</span>
        </label>

        {!half.isOpen && (
          <span className="text-red-500 text-sm">Closed</span>
        )}

        {half.isOpen && (
          <div className="flex gap-2">
            <input
              type="time"
              value={half.startTime}
              min={getMinTime()}
              onChange={(e) => onTimeChange("startTime", e.target.value)}
              className="border p-1 rounded"
            />
            <input
              type="time"
              value={half.endTime}
              min={getMinTime()}
              onChange={(e) => onTimeChange("endTime", e.target.value)}
              className="border p-1 rounded"
            />
          </div>
        )}
      </div>
    </div>
  );
};

// ✅ Props
DateTimePicker.propTypes = {
  mode: PropTypes.oneOf(["auto", "manual"]).isRequired,
  date: PropTypes.string.isRequired,
  onDateChange: PropTypes.func, // only needed for manual
  half: PropTypes.shape({
    name: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
};

export default DateTimePicker;